import Axios from 'axios';
import server from 'util/Server';
import Swal from 'sweetalert2';
import Storage from 'util/store/Storage';
import { sessionCaducada } from 'util/funciones'

export const getMediosPagos = async (negocio = '') => {
  return new Promise(function (resolve, reject) {
    const { empresasHijos } = Storage.getState()
    Axios.get(server.host + server.puertoCentury + "/api/medio-pago/empresa/" + (negocio || empresasHijos), { headers: { Authorization: server.obtenerToken() } })
      .then((res) => {
        if (res.status === server.responseOK) {
          const datos = res.data;
          resolve(datos);
        } else if (res.status === server.responseSesionCaducada) {
          resolve([]);
          sessionCaducada()
        }
      })
      .catch((err) => {
        console.error(err);
        reject(err, undefined);
      });
  });
};

export const deleteMedioPAgo = async (id, estado) => {
  return new Promise(function (resolve, reject) {
    Axios.put(server.host + server.puertoCentury + "/api/medio-pago/" + id + "/" + estado, {}, { headers: { Authorization: server.obtenerToken() } })
      .then((res) => {
        if (res.status === server.responseSucces) {
          Swal.fire("OK", "MEDIO DE PAGO " + (estado === "A" ? "ACTIVADO" : "INACTIVADO") + " CORRECTAMENTE", "success");
          Storage.dispatch({
            type: "ACTUALIZACION_DATOS",
            actualizarvista: true
          });
          resolve("");
        } else if (res.status === server.responseSesionCaducada) {
          sessionCaducada()
        }
      })
      .catch((err) => {
        console.error(err);
        reject(err, undefined);
      });
  });
};

export const findMedioPagoByID = async (identificadorMedioPago) => {
  return new Promise(function (resolve, reject) {
    Axios.get(server.host + server.puertoCentury + "/api/medio-pago/" + identificadorMedioPago, { headers: { Authorization: server.obtenerToken() } })
      .then((res) => {
        if (res.status === server.responseOK) {
          const datos = res.data.data;
          resolve(datos);
        } else if (res.status === server.responseSesionCaducada) {
          resolve([]);
          sessionCaducada()
        }
      })
      .catch((err) => {
        console.error(err);
        reject(err, undefined);
      });
  });
};


export const guardarMedioPagoPost = async (bodyMedioPago) => {
  return new Promise(function (resolve, reject) {
    Axios.post(server.host + server.puertoCentury + "/api/medio-pago/", bodyMedioPago, { headers: { Authorization: server.obtenerToken() } })
      .then((res) => {
        if (res.status === server.responseSucces) {
          Storage.dispatch({
            type: "ACTUALIZACION_DATOS",
            actualizarvista: true
          });
          resolve(true);
        } else if (res.status === server.responseSesionCaducada) {
          resolve(false);
          sessionCaducada()
        }
      })
      .catch((err) => {
        console.error(err);
        reject(err, undefined);
      });
  });
};

/*   guardarMedioPago = async (data: bodyMedioPago): Promise<boolean | string> => {
    try {
      const result = await this.mediosPagosApi.guardarMedioPago<any>(data)
      return true
    } catch ({ error }) {
      Logger.error('error MediosPagosService guardarMedioPago ', error as string)
      return error as string
    }
  }

  guardarMedioPago = async <T>(bodyMedioPago: bodyMedioPago): Promise<T> => http.post<T>(['medio-pago'].join('/'), bodyMedioPago, Server.puertoCentury)

  */


export const actualizarMedioPagoPut = async (bodyMedioPago) => {
  return new Promise(function (resolve, reject) {
    Axios.put(server.host + server.puertoCentury + "/api/medio-pago/", bodyMedioPago, { headers: { Authorization: server.obtenerToken() } })
      .then((res) => {
        if (res.status === server.responseSucces) {
          Storage.dispatch({
            type: "ACTUALIZACION_DATOS",
            actualizarvista: true
          });
          resolve(true);
        } else if (res.status === server.responseSesionCaducada) {
          sessionCaducada()
        }
      })
      .catch((err) => {
        console.error(err);
        reject(err, false);
      });
  });
};


/* actualizarMedioPago = async (data: bodyMedioPago): Promise<boolean | string> => {
  try {
    const result = await this.mediosPagosApi.actualizarMedioPago<any>(data)
    return true
  } catch ({ error }) {
    Logger.error('error MediosPagosService actualizarMedioPago ', error as string)
    return error as string
  }
}

actualizarMedioPago = async <T>(bodyMedioPago: bodyMedioPago): Promise<T> => http.put<T>(['medio-pago'].join('/'), bodyMedioPago, Server.puertoCentury)
 */



export const getFormasDePago =  () =>{
  return new Promise(function (resolve, reject) {
    Axios.get(server.host + server.puertoCentury + "/api/forma-pago" , { headers: { Authorization: server.obtenerToken() } })
      .then((res) => {
        if (res.status === server.responseOK) {
          const datos = res.data;
          resolve(datos);
        } else if (res.status === server.responseSesionCaducada) {
          resolve([]);
          sessionCaducada()
        }
      })
      .catch((err) => {
        console.error(err);
        reject(err, undefined);
      });
  });
}

export const getProgramasLoyalty =  () =>{
  return new Promise(function (resolve, reject) {
    Axios.get(server.host + server.puerto_integracion_sap + "/api/v1/loyaltySettings" , { headers: { Authorization: server.obtenerToken() } })
      .then((res) => {
        if (res.status === server.responseOK) {
          const datos = res.data;
          resolve(datos);
        } else if (res.status === server.responseSesionCaducada) {
          resolve([]);
          sessionCaducada()
        }
      })
      .catch((err) => {
        console.error(err);
        reject(err, undefined);
      });
  });
}
